// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"391":"8fca147fdfe690b9","2722":"0f79dbe9ea1e3c77","3877":"fe336940f98fdfab","3983":"e3230a7bfe318af5","7584":"d9652db206d50763"}[chunkId] + ".css";
};